import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'
import { FORM_ERROR } from 'final-form'
import { withTranslation } from 'react-i18next'
import Cookies from 'universal-cookie'

import ValidationCodeView from './validation-code-view'
import {
  verifyUserPasswordRequestCode,
  requestNewUserPassword,
  confirmationCodeValidator,
  SMS_RESEND_STATUSES,
  PASSWORD_REQUEST_EMAIL_COOKIE_NAME as EMAIL_COOKIE_NAME,
  VERIFICATION_CODE_COOKIE_NAME,
  PASSWORD_REQUEST_COOKIE_OPTIONS as COOKIE_OPTIONS,
} from '@portal/kit/pkg/services'

import { getSmsResendStatus } from 'helpers/sms'

const cookies = new Cookies()

class ValidationCodeContainer extends Component {
  state = {
    resendStatus: SMS_RESEND_STATUSES.UNRESOLVED,
  }

  validateCode = async (values) => {
    try {
      await verifyUserPasswordRequestCode(this.props.email, values.code)

      cookies.set(EMAIL_COOKIE_NAME, this.props.email, COOKIE_OPTIONS)
      cookies.set(VERIFICATION_CODE_COOKIE_NAME, values.code, COOKIE_OPTIONS)

      this.props.history.push('/login/password-recovery/sms')
    }
    catch(e) {
      const isInvalid = e.response && (e.response.status === 422 || e.response.status === 401)

      return {
        [FORM_ERROR]: isInvalid ? this.props.t('account.phone_number.code.invalid') : this.props.t('form.error')
      }
    }
  }

  resendCode = async () => {
    try {
      await requestNewUserPassword(this.props.email)
      this.setState({ resendStatus: SMS_RESEND_STATUSES.SUCCESS })
    }
    catch(e) {
      this.setState({ resendStatus: getSmsResendStatus(e) })
    }
  }

  render() {
    return (
      <Form
        onSubmit={this.validateCode}
        validate={confirmationCodeValidator}
        render={formProps => (
          <ValidationCodeView
            {...formProps}
            resendCode={this.resendCode}
            resendStatus={this.state.resendStatus}
            resendStatuses={SMS_RESEND_STATUSES}
            previousStep={this.props.previousStep}
          />
        )}
      />
    )
  }
}

ValidationCodeContainer.propTypes = {
  history: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
}

export default compose(
  withRouter,
  withTranslation(),
)(ValidationCodeContainer)
